import { createAction, createApiAction } from '@saucelabs/sl-util-redux';

import * as api from './api';
import * as types from './types';

export const cleanup = createAction(types.CLEANUP);
export const changePage = createAction(types.CHANGE_PAGE);
export const changePerPage = createAction(types.CHANGE_PER_PAGE);
export const resetPage = createAction(types.RESET_PAGE);

export const getArchivedJobs = createApiAction(
  types.ARCHIVED_JOBS_GET,
  (payload) => api.getArchivedJobs(payload),
  { meta: { skipErrorPage: true } },
);
